import axios from "axios";
import Errores from "@/utils/Errores";
let loginClaveUnica = async credenciales => {
  let login = await axios;
  location.href = API.CLAVEUNICA + "login/claveunica";
  return "";
};

export default {
  loginClaveUnica
};



// WEBPACK FOOTER //
// ./src/services/ApiClaveUnica.js